import { render, staticRenderFns } from "./show_view.vue?vue&type=template&id=7244fbf0"
import script from "./show_view.vue?vue&type=script&lang=js"
export * from "./show_view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports